// extracted by mini-css-extract-plugin
module.exports = {"container":"shared-components-Tabs-Tab__container--2r7Y9","active":"shared-components-Tabs-Tab__active--1Y3-x"};